import { booleanAttribute, BOOLEAN_ATTRIBUTE_TYPES } from "#ce/utils/props";

export const finderScopeProps = Object.freeze({
  /**
   * Editable dependencies, excluding pagination, availability, and blank values.
   * A bare attribute or true selects all eligible filters; omitted or false selects none.
   * JSON arrays and property arrays select named parameters.
   * @type {Boolean|Array|String}
   */
  filterScopes: booleanAttribute(undefined, {
    type: [...BOOLEAN_ATTRIBUTE_TYPES, Array],
  }),

  /** Explicit option scope for a standalone filter fixture. @type {Object|String} */
  scope: {
    type: [Object, String],
    default: undefined,
  },

  /** Explicit finder association. A supplied value reports `FINDER_LINK_NOT_SUPPORTED` from `#ce/shared/finder-association`. */
  finder: {
    type: String,
    default: undefined,
  },
});
